<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
@if (formLoading) {
  <div class="progress-spinner">
    <app-spinner [formLoading]="formLoading"></app-spinner>
  </div>
}

<p-table #pt [value]="definitions" [lazy]="true" (onLazyLoad)="loadDefinitions($event)" dataKey="testDefinitionId"
  selectionMode="single" [(selection)]="selectedDefinition" (onRowSelect)="onRowSelect($event)" [loading]="loading"
  [paginator]="true" [rows]="100" [rowsPerPageOptions]="[100,500,1000]" showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped"
  [resizableColumns]="true" [autoLayout]="true" [responsive]="true">

  <ng-template pTemplate="caption">
    <div class="d-flex justify-content-between">
      <span style="font-size: 1.2rem; font-weight: 600;">Quality Test Rule Definitions</span>
      <button pButton pRipple class="p-button" icon="pi pi-plus" label="New Rule"
        style="padding: 0.643rem 0.75rem !important;"
        (click)="openNew()"></button>
    </div>
  </ng-template>

  <ng-template pTemplate="header">
    <tr>
      <th pSortableColumn="testName">Test Name <p-sortIcon field="testName"></p-sortIcon></th>
      <th pSortableColumn="testCategory">Category <p-sortIcon field="testCategory"></p-sortIcon></th>
      <th pSortableColumn="ruleType">Rule Type <p-sortIcon field="ruleType"></p-sortIcon></th>
      <th pSortableColumn="ruleField">Rule Field <p-sortIcon field="ruleField"></p-sortIcon></th>
      <th pSortableColumn="severity">Severity <p-sortIcon field="severity"></p-sortIcon></th>
      <th pSortableColumn="scoreWeight">Weight <p-sortIcon field="scoreWeight"></p-sortIcon></th>
      <th pSortableColumn="isActive">Active <p-sortIcon field="isActive"></p-sortIcon></th>
      <th style="width: 80px;"></th>
    </tr>
    <tr>
      <th><input pInputText type="text" [style]="{'width':'100%'}"
        (input)="pt.filter($event.target.value, 'testName', 'contains')"></th>
      <th><input pInputText type="text" [style]="{'width':'100%'}"
        (input)="pt.filter($event.target.value, 'testCategory', 'contains')"></th>
      <th><input pInputText type="text" [style]="{'width':'100%'}"
        (input)="pt.filter($event.target.value, 'ruleType', 'contains')"></th>
      <th><input pInputText type="text" [style]="{'width':'100%'}"
        (input)="pt.filter($event.target.value, 'ruleField', 'contains')"></th>
      <th>
        <p-dropdown [style]="{'width':'100%'}" appendTo="body"
          [options]="[{label:'FAIL',value:'FAIL'},{label:'WARN',value:'WARN'},{label:'INFO',value:'INFO'}]"
          (onChange)="pt.filter($event.value, 'severity', 'in')" placeholder="All" [showClear]="true">
        </p-dropdown>
      </th>
      <th></th>
      <th>
        <p-dropdown [style]="{'width':'100%'}" appendTo="body"
          [options]="[{label:'Yes',value:1},{label:'No',value:0}]"
          (onChange)="pt.filter($event.value, 'isActive', 'in')" placeholder="All" [showClear]="true">
        </p-dropdown>
      </th>
      <th></th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-def>
    <tr [pSelectableRow]="def">
      <td>{{def.testName}}</td>
      <td>{{def.testCategory}}</td>
      <td>{{def.ruleType}}</td>
      <td>{{def.ruleField}}</td>
      <td>
        <p-tag [value]="def.severity" [severity]="getSeverityTag(def.severity)"></p-tag>
      </td>
      <td>{{def.scoreWeight}}</td>
      <td>
        <i class="pi" [ngClass]="def.isActive === 1 ? 'pi-check-circle' : 'pi-times-circle'"
          [style.color]="def.isActive === 1 ? '#22c55e' : '#ef4444'"></i>
      </td>
      <td>
        <i class="pi pi-pencil" style="color:blue; font-size:110%; padding-right:12px; cursor:pointer;"
          (click)="openForm(def)"></i>
        <i class="pi pi-trash" style="color:#ef4444; font-size:110%; cursor:pointer;"
          (click)="onRowDelete(def)"></i>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr><td colspan="8">No rule definitions found.</td></tr>
  </ng-template>
</p-table>
